import { AfterContentInit, Directive, ElementRef, Input, NgZone } from '@angular/core';
import SimpleBar from 'simplebar';

@Directive({
  selector: '[codemiroScrollbar],codemiro-scrollbar',
  host: {
    class: 'codemiro-scrollbar'
  }
})
export class ScrollbarDirective implements AfterContentInit {

  @Input('codemiroScrollbar') options: Partial<any>;

  scrollbarRef: SimpleBar;

  constructor(private _element: ElementRef,
              private zone: NgZone) {
  }

  ngAfterContentInit() {
    this.zone.runOutsideAngular(() => {
      this.scrollbarRef = new SimpleBar(this._element.nativeElement, this.options);
    });
  }
}
